module.exports = __webpack_public_path__ + "img/container-shutdown.5230f306.png";